// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wl_a bie_b"};